import { Component, signal, effect, inject, computed } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarItemComponent } from '@shared/components/sidebar-item/sidebar-item.component';
import { AuthService } from '@core/services/auth.service';
import { SidebarMenuService } from '@core/services/sidebar-menu.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [SidebarItemComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private sidebarMenuService = inject(SidebarMenuService);

  activeItem = signal<string | null>(null);
  isSidebarOpen: boolean = false;
  isNavBtnSelected: boolean = false;

  readonly isProveedorProducto = computed(() =>
    this.authService.hasRole('PROVEEDOR_PRODUCTO'),
  );

  constructor() {
    effect(() => {
      this.isSidebarOpen = this.sidebarMenuService.isSidebarOpen();
    });
    effect(() => {
      this.isNavBtnSelected = this.sidebarMenuService.isNavBtnSelected();
    });
  }

  ngOnInit(): void {
    this.sidebarMenuService.loadFromLocalStorage();
  }

  openSidebar(): void {
    this.isSidebarOpen = true;
    this.sidebarMenuService.setSidebarOpen(true);
  }

  closeSidebar(): void {
    if (this.isNavBtnSelected) return;
    this.isSidebarOpen = false;
    this.sidebarMenuService.setSidebarOpen(false);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
